import React from 'react'
import { Col, FormGroup, Input, Label } from 'reactstrap'
import { H6, LI, UL } from '../../../../../AbstractElements'
import { IconCheckboxTitle } from '../../../../../Utils/Constants'
import { iconCheckboxData } from '../../../../../Data/Forms/FormControlsData'

export default function IconCheckbox() {
    
    return (
        <Col xl={4} sm={6} className="order-xl-0 order-sm-1">
            <div className="card-wrapper border rounded-3 h-100 checkbox-checked">
                <H6 className="sub-title">{IconCheckboxTitle}</H6>
                <FormGroup className="checkbox checkbox-primary ps-0 main-icon-checkbox" check>
                    <UL className='simple-list flex-row checkbox-wrapper'>
                        {iconCheckboxData.map((data) => (
                            <LI key={data.id}>
                                <Input className="checkbox-shadow" id={data.id} type="checkbox" defaultChecked={data.check === 'checked'} />
                                <Label htmlFor={data.id} check><i className={`fa fa-${data.icon}`}></i><span>{data.text}</span></Label>
                            </LI>
                        ))}
                    </UL>
                </FormGroup>
            </div>
        </Col>
    )
}
